// extracted by mini-css-extract-plugin
export var label = "_kp-2";
export var slideContainer = "_kp-0";
export var slider = "_kp-1";